import { CaDialogComponent } from '../../../../shared/dialogs/ca-dialog.base'
import { Component, forwardRef, Inject, OnDestroy, OnInit } from '@angular/core'
import { AttachmentService } from '../../services/attachment.service'
import { DialogService } from '../../../../core/services/dialog.service'
import { ErrorService } from '../../../../core/services/error.service'
import { AttachmentRouteTypeEnum } from '../../enums/attachment-route-type.enum'
import { Store } from '@ngrx/store'
import { Observable, Subscription } from 'rxjs'
import { selectAttachmentTypeScanState } from '../../../../domain/attachment/components/attachment-type-scan-data/state/common-domain-components.selectors'
import { ContractTypeEnum } from '../../../../shared/enums/contract-type.enum'
import { ComponentModeEnum } from '../../../../shared/enums/component-mode.enum'
import { selectContractShowContractOwnersLength } from '../../../../features/contracts/contract/show/state/show.selectors'
import { selectContractEditOwnersLength } from '../../../../features/contracts/contract/edit/state/edit.selectors'
import { selectSubcontractShowContractOwnersLength } from '../../../../features/contracts/subcontract/show/state/subcontract-show.selectors'
import { selectSubcontractEditOwnersLength } from '../../../../features/contracts/subcontract/edit/state/subcontract-edit.selectors'
import {
    selectNonCadastralContractCreateOwnersLength,
} from '../../../../features/non-cadastral/non-cadastral-contract/create/state/non-cadastral-contract-create.selectors'

@Component({
    selector: 'ca-edit-scan-dialog',
    templateUrl: './edit-scan-dialog.html',
    standalone: false
})
export class EditScanDialogComponent extends CaDialogComponent<{
    entityId: number;
    mode: string;
    routeType: AttachmentRouteTypeEnum;
    task: string;
}, boolean> implements OnInit, OnDestroy {

    attachmentId: number
    entityId: number
    loading = false
    mode: string
    routeType: AttachmentRouteTypeEnum
    task: string
    uploadedType: string
    ownersLength: number
    checkedIds: number[]
    checkedAll: boolean

    ownersLength$: Observable<number>
    #selectAttachmentTypeScanState: Subscription
    #ownersLength: Subscription

    constructor(@Inject(Store) private store: Store,
                @Inject(forwardRef(() => AttachmentService)) private attachmentService: AttachmentService,
                @Inject(forwardRef(() => DialogService)) private dialogService: DialogService,
                @Inject(ErrorService) private errorService: ErrorService,
                ) {
        super()

        this.#selectAttachmentTypeScanState = this.store.select(selectAttachmentTypeScanState).subscribe(data => {
            this.uploadedType = data.uploadedType
            this.checkedAll = data.checkedAll
            this.checkedIds = data.checkedIds
            this.attachmentId = data.attachmentId
        })
    }

    ngOnInit() {
        switch (this.task) {
            case ContractTypeEnum.CONTRACT:
                this.ownersLength$ = this.mode === ComponentModeEnum.SHOW ? this.store.select(selectContractShowContractOwnersLength) : this.store.select(selectContractEditOwnersLength)
                break
            case ContractTypeEnum.SUBCONTRACT:
                this.ownersLength$ = this.mode === ComponentModeEnum.SHOW ? this.store.select(selectSubcontractShowContractOwnersLength) : this.store.select(selectSubcontractEditOwnersLength)
                break
            case ContractTypeEnum.NONCADASTRALCONTRACT:
                this.ownersLength$ = this.store.select(selectNonCadastralContractCreateOwnersLength)
                break
        }
        this.#ownersLength = this.ownersLength$.subscribe(number => this.ownersLength = number)
    }

    ngOnDestroy() {
        this.#selectAttachmentTypeScanState?.unsubscribe()
        this.#ownersLength?.unsubscribe()
    }

    closeModal(result: boolean): void {
        super.result = result
        super.close()
    }

    saveEditedScan(): void {
        if (this.validate()) {
            this.loading = true

            this.attachmentService
             .saveEditedScan(this.routeType, this.attachmentId, this.uploadedType, this.checkedIds)
             .then(() => {
                     this.closeModal(true)
             },
              error => {
                  this.errorService
                   .onErrorResponseAlertUser(error, 'Při ukládání skenu došlo k chybě.')
                   .then(() => {
                       this.closeModal(false)
                   })
              })
        }
    }

    private validate(): boolean {
        if (!this.uploadedType) {
            this.dialogService.showWarningDialog('Je třeba vybrat typ naskenovaného dokumentu.')
            return false
        }
        if (this.ownersLength > 1 && this.checkedIds.length === 0) {
            this.dialogService.showWarningDialog('Je třeba vybrat aspoň jednoho propachtovatele.')
            return false
        }

        return true
    }
}